import React from "react";
import QuizCreator from "../components/QuizCreator";
import { createQuiz } from "../utils/api";

export default function CreateQuizPage() {
  const handleCreate = async (quizData) => {
    const response = await createQuiz(quizData);
    alert(response.message);
  };

  return <QuizCreator onSubmit={handleCreate} />;
}
